<template>
 <el-container class="course-container row-course-card">
  <el-aside style="width:30%"></el-aside>
  <el-container>
    <el-main>
     <el-form ref="form" label-width="100px" :model="model" :rules="rules">
       <el-form-item label="业务:" prop="CategoryId">
          <el-select 
            @change="onCategoryChange()"
            v-model="model.CategoryId"
            placeholder="请选择业务"
          >
            <el-option
              v-for="item in categroyList"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学期:" prop="TermId" v-if="modelData.CourseType != 2">
          <el-select
            @change="onTermChange()"
            v-model="model.TermId"
            placeholder="请选择学期"
          >
            <el-option
              v-for="term in termList"
              :key="term.Id"
              :label="term.DisplayLable"
              :value="term.Id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="校区:" prop="CampusId">
          <el-select 
            @change="onCampusChange()"
            v-model="model.CampusId"
            placeholder="请选择校区"
          >
            <el-option
              label="无校区"
              value=""> </el-option>
            <el-option
              v-for="item in campusList"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="课程名称:" prop="CourseId" >
          <el-select 
            filterable
            v-on:change="onCourseChange()"
            v-model="model.CourseId"
            placeholder="请选择课程"
          >
            <el-option
              v-for="course in courseList"
              :key="course.Id"
              :label="course.Name"
              :value="course.Id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="速成老师:">
          <!-- <el-select  
            filterable
            v-on:change="onTeacherChange()"
            v-model="model.TeacherId"
            placeholder="请选择老师"
          > -->
            <!-- <el-option :key="0" label="未选择" :value="0"></el-option> -->
            <!-- <el-option
              v-for="item in teacherList"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select> -->
          
          <el-tag v-for="(item, index) in teachers" :key="index">{{item.Name}}</el-tag>
          
        </el-form-item>

        <el-form-item class="text-right">
          <a
            class="delete-btn"
            @click="removeCourse()"
          >删除</a>
        </el-form-item>
     </el-form>
     </el-main>
  </el-container>
  </el-container>
</template>

<script>

export default {
  props: {
    campusList:Array,
    courseCategroyList:Array,
    index:Number,
    modelData:{
      Id :Number,
      UniversityName :String,
      CategoryId:Number | String,
      CourseId :Number,
      TermId :Number,
      TeacherId:Number,
      StudentId :Number,
      TeacherName :String,
      CourseType :Number,
      CampusId :Number,
    }
  },
  data() {
    var test = (rule, value, callback) => {
        if (!value) {
          callback(new Error('请输入'));
        } else {
          callback();
        }
      };
    return {
      categroyList:[],
      termList: [],
      teacherList:[],
      teachers:[],
      courseList:[],
      model:{
        Id :0,
        UniversityName :"",
        CategoryId:"",
        CourseId :"",
        TermId :"",
        TeacherId:"",
        StudentId :"",
        TeacherName :"",
        CourseType :"",
        CampusId :"",
      },
      rules: {
        CategoryId: [
          {
            required: true,
            message: "请选择业务",
            trigger: "blur"
          }, 
          { validator: test, trigger: 'blur' }
        ],
        CourseId: [
          {
            required: true,
            message: "请选择课程",
            trigger: "blur"
          }
        ],
        TermId: [
          {
            required: true,
            message: "请选择学期",
            trigger: "blur"
          }
        ],
        CampusId: [
          {
            required: true,
            message: "请选择校区",
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    this.model = this.modelData;
    this.init();
  },
  watch: {
    courseCategroyList:function(){
      this.init();
    },
    modelData:function(){
      this.model = this.modelData;
      this.loadTermAndTeacherList();
      this.loadCourseList();
    }
  },
  methods: {
    filterTeacher (teachers) {
    return teachers.filter(function (teacher) {
      return teacher.CampusId==this.model.CampusId && teacher.CourseId==this.model.CourseId;
    })
  },
    checkAllInputs() {
      let isValid = true;
      this.$refs.form.validate(valid => {
        if (!valid) {
          isValid = false;
          return;
        }
      });
  
      return isValid;
    },
    init(){   
      if (!!this.courseCategroyList && this.courseCategroyList.length > 0){
        this.categroyList = this.courseCategroyList.map(i => {return {Id:i.Id, Name: i.Name};});
        this.loadTermAndTeacherList();
        this.loadCourseList();
        this.loadTeachers();
      }
    },
    loadTermAndTeacherList(){
      let isFind = false;
      if (!!this.model && !!this.model.CategoryId){
        let category = this.courseCategroyList.find(i=> i.Id == this.model.CategoryId);
        if (!!category){
          this.termList = category.TrainingCourseTermList.map(i => i.Term);
          this.teacherList = category.TeacherList;
          isFind = true;
          if (this.modelData.CourseType == 2){
            this.modelData.TermId = this.termList[0].Id;
          }
        }
      }
      
      if (!isFind){
        this.termList = [];
        this.teacherList = [];
      }
    },
    loadCourseList(){
      let isFind = false;
      if (!!this.model.CategoryId){
        let category = this.courseCategroyList.find(i=> i.Id == this.model.CategoryId);
        if (!!category){
          let courseTermList = category.TrainingCourseTermList;
          let list = courseTermList.filter(i => i.Term.Id == this.model.TermId);
          if (list.length > 0){
            this.courseList = list[0].CourseList;
            isFind = true;
          }
         
        }
      }
      
      if (!isFind){
        this.courseList = [];
      }
    },
     loadTeachers(){
        this.teachers=this.teacherList.filter(c=> c.CourseId==this.model.CourseId && c.CampusId==this.model.CampusId);
     },
    onCategoryChange(){
      this.model.TermId = null;
      this.model.TeacherId = null;
      this.loadTermAndTeacherList()
      this.loadCourseList();
    },
    onTermChange(){
      this.loadCourseList();
    },
    onCampusChange(){
       this.loadCourseList();
    },
    onCourseChange(){
      this.loadTeachers();
    },
    onTeacherChange(){

    },
    removeCourse(){
      this.$emit("remove", this.index);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/training/speedupCourseEditor.vue